import React from 'react';
import {BaseFieldText} from './components/text';
import {BaseFieldCheckbox} from './components/checkbox';
import {BaseFieldRadio} from './components/radio';
import {BaseFieldDate} from './components/date';
import {BaseFieldSelect} from './components/select';
import {BaseFieldSelectDinamic} from './components/select/dynamic';
import {BaseFieldProps} from './types';

// @ts-ignore
export const BaseField: React.FC<BaseFieldProps> = (ownProps) => {
  // redux-form может передавать props через ownProps.props
  const fieldProps = (ownProps as any).props || {};
  const props: BaseFieldProps = {
    ...ownProps,
    ...fieldProps,
    variant: ownProps.variant || fieldProps.variant || 'standard',
  };

  // Проверяем, что input и type определены
  if (!props.input || !props.type) {
    return null;
  }

  switch (props.type) {
    case 'number':
    case 'text':
    case 'phone':
    case 'hidden':
    case 'password':
    case 'digits':
      return <BaseFieldText {...props} />;
    case 'checkbox':
      return <BaseFieldCheckbox {...props} />;
    case 'radio':
      return <BaseFieldRadio {...props} />;
    case 'date':
      return <BaseFieldDate {...props} />;
    case 'select':
      return <BaseFieldSelect {...props} />;
    case 'selectDinamic':
      return <BaseFieldSelectDinamic {...props} />;
    default:
      return null;
  }
};

export const BaseFieldWrapper = (props: BaseFieldProps) => {
  return (
    <BaseField
      {...{
        ...props,
        input: {
          ...props.input,
          value: props.type === 'checkbox' ? !!props.input.value : props.input.value,
        },
      }}
    />
  );
};
